const Login = () => {
  return (
    <div>
      <h1>This is the Login Page</h1>
      <br />
      <input type="text" placeholder="Email" />
      <button>
        Password
      </button>
    </div>
  )
}

export default Login
